export const pageSize = 50
export const INTEGRATION_CLIENTS = ['axenita', 'ineskis', 'aeskulap'];
export const nonAudioTools = ['Summary AI', 'Invoice AI'];
export const toolsToExcludeFromSelection = ["Templates", "MPAssist Chat", "Invoice AI"];

export const audioLanguages = [
    { name: "Arabic", value: "ar" },
    { name: "Bulgarian", value: "bg" },
    { name: "Chinese", value: "zh" },
    { name: "Czech", value: "cs" },
    { name: "Danish", value: "da" },
    { name: "Dutch", value: "nl" },
    { name: "English", value: "en" },
    { name: "Estonian", value: "et" },
    { name: "Finnish", value: "fi" },
    { name: "French", value: "fr" },
    { name: "German", value: "de" },
    { name: "Greek", value: "el" },
    { name: "Hungarian", value: "hu" },
    { name: "Indonesian", value: "id" },
    { name: "Italian", value: "it" },
    { name: "Japanese", value: "ja" },
    { name: "Korean", value: "ko" },
    { name: "Latvian", value: "lv" },
    { name: "Lithuanian", value: "lt" },
    { name: "Norwegian", value: "no" },
    { name: "Polish", value: "pl" },
    { name: "Portuguese", value: "pt" },
    { name: "Romanian", value: "ro" },
    { name: "Russian", value: "ru" },
    { name: "Slovak", value: "sk" },
    { name: "Slovenian", value: "sl" },
    { name: "Spanish", value: "es" },
    { name: "Swedish", value: "sv" },
    { name: "Turkish", value: "tr" },
    { name: "Ukrainian", value: "uk" }
];

export const reportLanguages = [
    ...audioLanguages,
    { name: "German (Switzerland)", value: "german (switzerland)" },
    { name: "Vietnamese", value: "vi" },
    { name: "Herbrew", value: "he" },
    { name: "Thai", value: "th" },
];
